import {
    gallonsPerAcreToLitersPerHectare,
    litersPerHectareToGallonsPerAcre
} from 'utils/applicationRateUtil';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import StepperField from 'components/StepperField';

import {
    LABELS,
    NOZZLE_PERCENTAGE,
    SPRAY_RATE,
    SPRAY_RATE_METRIC_MAX
} from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/SpraySettingsSection/constants';

import { TEST_ID } from './constants';
import type { FunctionComponent, NumericChangeParams, Props } from './types';

import styles from './styles.module.scss';

const SpraySpecificFields: FunctionComponent<Props> = ({
    className = '',
    nozzleRatePercentage,
    onChange,
    rateLitersPerHectare,
    testId = TEST_ID
}) => {
    const handleRateChange = ({ value }: NumericChangeParams) => {
        const metric = Math.min(gallonsPerAcreToLitersPerHectare(value), SPRAY_RATE_METRIC_MAX);

        onChange({ spraySettings: { rateLitersPerHectare: metric } });
    };

    const handleNozzleChange = ({ value }: NumericChangeParams) => {
        onChange({ spraySettings: { nozzleRatePercentage: value } });
    };

    return (
        <VerticalContainer className={`${className} ${styles.spraySpecificFields}`} testId={testId}>
            <StepperField
                label={LABELS.sprayRate}
                max={SPRAY_RATE.max}
                min={SPRAY_RATE.min}
                onChange={handleRateChange}
                step={SPRAY_RATE.step}
                value={litersPerHectareToGallonsPerAcre(rateLitersPerHectare)}
            />

            <StepperField
                label={LABELS.nozzlePercentage}
                max={NOZZLE_PERCENTAGE.max}
                min={NOZZLE_PERCENTAGE.min}
                onChange={handleNozzleChange}
                step={NOZZLE_PERCENTAGE.step}
                value={nozzleRatePercentage}
            />
        </VerticalContainer>
    );
};

export default SpraySpecificFields;
